module.exports = __webpack_public_path__ + "img/ing-dark.942e938.png";